import React from 'react';
import cmsParser from '../cmsParser';
import htmlParser from 'html-react-parser';

import { PulloutTextStripProps } from 'Elements/PulloutTextStrip';

import { ImageCaptionProps } from 'Components/ImageCaption';

interface CivicCharterProps {
    text?: React.ReactNode;
}

export interface CivicCharterLeftColumnProps extends CivicCharterProps {
    image?: ImageCaptionProps;
}

export interface CivicCharterRightColumnProps extends CivicCharterProps {
    pulloutTextStrip?: PulloutTextStripProps;
}

class CivicCharter {
    static CivicCharterLeftColumn(items: any[]): CivicCharterLeftColumnProps[] {
        const content: CivicCharterLeftColumnProps[] = [];

        items.map(item => {
            switch (item.type) {
                case 'richText':
                    content.push({ text: htmlParser(item.value) });
                    break;
                case 'image':
                    content.push({
                        image: {
                            image: cmsParser.image(item.value)
                        }
                    });

                    break;
                default:
                    return {};
            }
        });

        return content;
    }

    static CivicCharterRightColumn(items: any[]): CivicCharterRightColumnProps[] {
        const content: CivicCharterRightColumnProps[] = [];

        items.map(item => {
            switch (item.type) {
                case 'richText':
                    content.push({ text: htmlParser(item.value) });
                    break;
                case 'pulloutTextStrip':
                    content.push({
                        pulloutTextStrip: {
                            description: item.value.text,
                            backgroundColour: item.value.colourPicker.colourPicker
                                ? cmsParser.getThemeColour(item.value.colourPicker.colourPicker)
                                : undefined
                        }
                    });
                    break;
                default:
                    return {};
            }
        });

        return content;
    }
}

export default CivicCharter;
